module.exports = __webpack_public_path__ + "assets/media/morning.7ff4b4a3.mp3";